import React, { useState } from 'react';
import { Switch, Link } from 'react-router-dom';
import MainBar from '../Components/MainBar/MainBar';
import { Layout, Menu, Icon } from 'antd';
import AdminProjects from './AdminProjects';
import AdminActivities from './AdminActivities';
import AdminUsers from './AdminUsers';
import AdminCalendar from './AdminCalendar/AdminCalendar';
import AdminReports from './AdminReports';
import AdminSettings from './AdminSettings';
import PrivateRoute from '../Components/PrivateRoute/PrivateRoute';
import logo from '../img/BLACKlogo.svg';
import TimeSheet from './TimeSheet/TimeSheet';
import SelfService from './SelfService';

const { Header, Sider, Footer } = Layout;

const Admin = () => {
  const [collapsed, setCollapsed] = useState(false);

  const onCollapse = (collapsed) => {
    setCollapsed(collapsed);
  };

  return (
    <>
      <Layout style={{ minHeight: '100vh' }}>
        <Sider collapsible collapsed={collapsed} onCollapse={onCollapse}>
          <div
            className="logo"
            style={{
              padding: '6px',
              height: '61px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img src={logo} width={36} />
          </div>
          <Menu theme="dark" defaultSelectedKeys={['2']} mode="inline">
            <Menu.Item key="1">
              <Link to="/admin/timesheet">
                <Icon type="clock-circle" />
                <span>Timesheet</span>
              </Link>
            </Menu.Item>
            <Menu.Item key="2">
              <Link to="/admin/projects">
                <Icon type="pie-chart" />
                {/* <Icon type="project" /> */}
                <span>Projekty</span>
              </Link>
            </Menu.Item>
            <Menu.Item key="3">
              <Link to="/admin/activities">
                <Icon type="build" />
                <span>Inne aktywności</span>
              </Link>
            </Menu.Item>
            <Menu.Item key="4">
              <Link to="/admin/users">
                <Icon type="smile" />
                <span>Pracownicy</span>
              </Link>
            </Menu.Item>
            <Menu.Item key="5">
              <Link to="/admin/selfservice">
                <Icon type="clock-circle" />
                <span>Panel użytkownika</span>
              </Link>
            </Menu.Item>
            <Menu.Item key="6">
              <Link to="/admin/calendar">
                <Icon type="calendar" />
                <span>Kalendarz</span>
              </Link>
            </Menu.Item>
            <Menu.Item key="7">
              <Link to="/admin/reports">
                <Icon type="export" />
                <span>Raporty</span>
              </Link>
            </Menu.Item>
            {/*<Menu.Item key="10">*/}
            {/*  <Link to="/admin/settings">*/}
            {/*    <Icon type="setting" />*/}
            {/*    <span>Ustawienia</span>*/}
            {/*  </Link>*/}
            {/*</Menu.Item>*/}
          </Menu>
        </Sider>
        <Layout>
          <Header
            style={{
              background: '#fff',
              boxShadow: '0 1px 4px 0 rgba(0,21,41,.08)',
              padding: 0,
              zIndex: 99,
            }}
          >
            <MainBar />
          </Header>
          <Switch>
            <PrivateRoute path="/admin/timesheet" component={TimeSheet} />
            <PrivateRoute path="/admin/projects" component={AdminProjects} />
            <PrivateRoute
              path="/admin/activities"
              component={AdminActivities}
            />
            <PrivateRoute path="/admin/users" component={AdminUsers} />
            <PrivateRoute path="/admin/selfservice" component={SelfService} />
            <PrivateRoute path="/admin/calendar" component={AdminCalendar} />
            <PrivateRoute path="/admin/reports" component={AdminReports} />
            {/*<PrivateRoute path="/admin/settings" component={AdminSettings} />*/}
          </Switch>
          <Footer style={{ textAlign: 'center' }}>Time Cube, 2020</Footer>
        </Layout>
      </Layout>
    </>
  );
};

export default Admin;
